import moment from 'utils/cops-moment';

const mapUnavailability = (unavailability) => {
  const startMoment = moment(unavailability.start);
  const durationInMinutes = moment.duration(unavailability.duration).asMinutes();
  const endMoment = startMoment.clone().add(durationInMinutes, 'minutes');

  return {
    start: unavailability.start,
    end: unavailability.end,
    duration: unavailability.duration,
    type: unavailability.type,
    startMoment,
    durationInMinutes,
    endMoment,
  };
};

export default mapUnavailability;
